export const USABLE_NET_BANNER_HEIGHT = 40;
